import './TransportModeIcon.scss'

import { HDSIcon } from '@here/hds-react-components'
import classNames from 'classnames'
import React from 'react'

export enum TransportModeIconMode {
  Car = 'driving',
  ParkedCar = 'parking',
  Train = 'rail-local',
  Underground = 'metro',
  Pedestrian = 'walking',
  Tram = 'tram',
  Bike = 'bicycle',
  Motorcycle = 'motorcycle',
  Bus = 'bus',
  Scooter = 'scooter',
  Ferry = 'ferry',
  Unknown = 'unknown',
}

export interface TransportModeIconProps {
  mode: TransportModeIconMode
  color?: string
  className?: string
}

export default function TransportModeIcon({
  mode,
  color,
  className,
}: TransportModeIconProps): JSX.Element {
  return (
    <div className={classNames('TransportMode__icon', className)} style={{ borderColor: color }}>
      <HDSIcon
        name={mode}
        category="travel-transport-tracking"
        style={
          {
            '--hds-icon-color': color,
          } as React.CSSProperties
        }
      ></HDSIcon>
    </div>
  )
}
